var _g;
import * as React from "react";
var SvgGenericPropertyCustom = function SvgGenericPropertyCustom(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.184 10.836-9.057-9.052-.607-.607a.738.738 0 0 0-1.04 0l-9.664 9.659c-.288.288-.443.67-.44 1.078.01.825.696 1.484 1.52 1.484h.997v7.633h16.214v-7.633h1.017c.401 0 .778-.157 1.062-.441a1.49 1.49 0 0 0 .438-1.062c0-.398-.157-.775-.44-1.06Zm-8.872 8.508h-2.624v-4.782h2.624v4.782Zm5.108-7.634v7.634h-3.608V14a.937.937 0 0 0-.937-.938h-3.75a.937.937 0 0 0-.938.938v5.344H5.58V11.71H3.33l8.672-8.665.542.542 8.128 8.123H18.42Z",
    fill: "#626980"
  })));
};
export default SvgGenericPropertyCustom;